<script setup lang="ts">
import type { Blocks, BreadcrumbListItem, Metadata } from 'types/index';
import type { NewsListItemContent, NewsDetailPageContentResponse } from '~/types/news';

const { getListContent } = useContentApi();
const { path } = useRoute();
const newsList = ref<NewsListItemContent[]>([]);

const props = defineProps<{
  blocks: Blocks;
  content: NewsDetailPageContentResponse;
  breadcrumbs: BreadcrumbListItem[];
  metadata: Metadata;
}>();

const computedBlocks = computed(() => {
  return props.blocks.blocks || {};
});

async function getList() {
  const { data } = await useAsyncData('NewsListPageListFetch', () =>
    getListContent<NewsListContent>(useFrontendBase(path), 1, 10, '', false),
  );

  if (data.value) {
    newsList.value = data.value.items;
  }
}

await getList();
</script>

<template>
  <section>
    <BaseComponentWrapper class="no-margin-top no-margin-bottom bg-gray-10">
      <div class="container">
        <div v-if="newsList?.length > 0">
          <PartialsNewsList
            :loading="false"
            :news-items="newsList"
          />
        </div>

        <BlockList
          v-if="computedBlocks"
          :blocks="computedBlocks"
        />
      </div>
    </BaseComponentWrapper>
  </section>
</template>
